import { useToast } from "@chakra-ui/react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { Pagination, PaginationSectionWrapper } from "../../../components/Pagination";
import { Loading } from "../../../components/ui/loading";
import { ResourceLoadingError } from "../../../components/ui/resource-loading-error";
import Workspace from "../../../components/workspace";
import { ApiResponse } from "../../../types";
import { GroupTypes } from "./group-types";
import groupTypeService from "./group.service";

type GroupType = {
   name: string;
   description: string;
};

const GroupTypeListContainer = ({ searchQuery = "" }) => {
   const [page, setPage] = useState(1);
   const [rows] = useState(10);
   const [totalPages, setTotalPages] = useState(1);
   const toast = useToast();
   const queryClient = useQueryClient();
   const refreshData = () => queryClient.invalidateQueries({ queryKey: ["group_types", page, rows, searchQuery] });

   const loadGroupTypes = async () => {
      try {
         const fetchResult = (await groupTypeService.getGroupTypes({
            page,
            rows,
            search: searchQuery,
         })) as any as ApiResponse;

         setTotalPages(fetchResult.totalPages);
         return fetchResult.data as GroupType[];
      } catch (error) {
         toast({ description: error.message, status: "error", title: "Group types loading failed" });
         throw new Error(error.message || error);
      }
   };

   const {
      data: groupTypes,
      error: fetchError,
      isLoading,
      isError,
   } = useQuery({ queryKey: ["group_types", page, rows, searchQuery], queryFn: loadGroupTypes });

   if (isLoading) return <Loading />;
   if (isError) return <ResourceLoadingError error={fetchError || ""} />;

   return (
      <Workspace.List>
         <GroupTypes groupTypes={groupTypes} refreshData={refreshData} />
         <PaginationSectionWrapper>
            {groupTypes.length ? <Pagination setPage={setPage} page={page} totalPages={totalPages} /> : null}
         </PaginationSectionWrapper>
      </Workspace.List>
   );
};

export default GroupTypeListContainer;
